<template>
  <tr>
    <td>{{ persona.nombre }} {{ persona.apellido }}</td>
    <td>{{ persona.email }}</td>
    <td>{{ persona.perfil }}</td>
    <td>Cuota # {{ persona.cuota_numero}}</td>
  </tr>
</template>

<script>
export default {
  name: 'ImpagosListaItem',
  components: {
  },
  props: ['persona'],
  data: function () {
    return {
      // store
    }
  },
  methods: {
  }
}
</script>
